import { Component, OnInit } from '@angular/core';
import { GRADIENT_ICONS } from 'src/app/constants/imagePath';
@Component({ selector: 'app-sol-automotive-oem', templateUrl: './automotive-oem.component.html', styleUrls: ['./automotive-oem.component.scss'], standalone: false })
export class AutomotiveOEMComponent implements OnInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-chip' },
    { id: 'outcomes', label: 'Outcomes', icon: 'bx-bar-chart-alt-2' },
  ];
  features = [
    { icon: 'bx-car', title: 'Connected Vehicle Platform', desc: 'End-to-end vehicle data ingestion, processing, and analytics for OEM fleet intelligence.' },
    { icon: 'bx-refresh', title: 'OTA Software Updates', desc: 'Push firmware, calibration, and software updates to millions of vehicles securely and reliably.' },
    { icon: 'bx-user-circle', title: 'Driver Profiling', desc: 'AI-driven driver behaviour analytics to power UBI products, safety programs, and personalisation.' },
    { icon: 'bx-store-alt', iconImage: GRADIENT_ICONS.VEHICLE_APP_STORE, title: 'Vehicle App Store', desc: 'Monetise in-car digital services and third-party applications via the Oasis ecosystem.' },
    { icon: 'bx-map-alt', title: 'Geo-Intelligence', desc: 'Live and historical trip data with geo-fencing, route analytics, and location-based services.' },
    // { icon: 'bx-shield', title: 'Cyber Security', desc: 'UNECE WP.29 aligned vehicle cybersecurity management integrated across the ConnectIQ stack.' },
  ];
  metrics = [
    { val: '50M+', label: 'Vehicles Supported' },
    { val: '99.99%', label: 'Platform Uptime' },
    { val: '<100ms', label: 'Telemetry Latency' },
  ];
  ngOnInit() {}
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
